// Module
var code = `<div appHeaderBar>
    <header-bar-title>Add Account</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <form name="CheckingAccountAdd" 
          id="CheckingAccountAdd" 
          tid="CheckingAccountAdd"  
          #checkingAccountAdd="ngForm"
          (submit)="preSubmit()">
        <div class="HOA-container">
            <div class="HOA-container__header">
                <h1 class="HOA-container__header-text">
                    My Account - Add Bank Account
                </h1>
            </div>
            <div class="HOA-container__content">
                <div class="HOA-flextable-component__subheader u-mT3 u-mB7">
                    Bank Account Details
                </div>
                <div class="HOA-flextable-component HOA-flextable-component__form HOA-Has-Default-Switch">
                    <div [ngClass]="{'is-invalid': routingErrorMsg}"
                         class="Field HOA-flextable-component__cell-input HOA-sm-order-2 HOA-lg-order-1">
                        <div class="HOA-flex-center-info-button">
                            <label class="Field-label HOA-flex-center-info-button" for="routingNumber">
                                Routing Number
                                <span class="asterisk-required">&nbsp;&#42;</span>
                            </label>
                            <button type="button"
                                    tid="routingNumberHelper"
                                    id="routingNumberHelper"
                                    class="u-mL3 u-pB2 u-posRelative HOA-flex-center-info-button"
                                    (click)="routingNumberHelper()">
                                <span class="Icon Icon--24 u-iconBlue">
                                    <svg focusable="false"
                                         xmlns="http://www.w3.org/2000/svg"
                                         width="24"
                                         height="24"
                                         viewBox="0 0 72 72">
                                        <title>Routing Number</title>
                                        <path class="stroke_layer"
                                              d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z"
                                              fill="none"
                                              stroke="#838383"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              stroke-width="3.8">
                                        </path>
                                        <path class="fill_layer"
                                              d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
                                              fill="#838383"
                                              stroke-width="3.8">
                                        </path>
                                        <path class="stroke_layer"
                                              data-name="stroke_layer"
                                              d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8 8.5 8.5 0
                                                0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1 1.4 2.1 7.4 7.4 0 0
                                                1 .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5 0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5
                                                1.4a9.9 9.9 0 0 0-1.7 1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8
                                                12.3 12.3 0 0 0-.1 1.7v2.6"
                                              fill="none"
                                              stroke="#838383"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              stroke-width="3.8">
                                        </path>
                                    </svg>
                                </span>
                            </button>
                        </div>
                        <input type="text"
                               stopccp
                               app-allow-pattern allowPattern="\\d"
                               numbers-only
                               class="Input"
                               id="routingNumber"
                               name="routingNumber"
                               tid="routingNumber"
                               maxlength="9"
                               [(ngModel)]="checkingAccount.routingNumber"
                               (change)="checkRoutingNumber()"
                               autocapitalize="off"
                               autocomplete="off"
                               autocorrect="off"
                               spellcheck="false"
                               required
                               attr.aria-invalid="{{!!routingErrorMsg}}"
                               attr.aria-describedby="{{routingErrorMsg && 'routingNumber-error' || undefined }}">
                        <span class="Field-error" id="routingNumber-error">{{routingErrorMsg}}</span>
                        <div *ngIf="isValidRoutingNumber" class="HOA-flextable-component__cell-value u-pT2">
                            {{checkingAccount.bankName}}
                        </div>
                    </div>

                    <div class="HOA-Make-Default-Absolute-Switch
                                Field
                                u-cf
                                HOA-flextable-component__cell-input
                                HOA-sm-order-1
                                HOA-lg-order-2">
                        <div class="HOA-Toggle-Align">
                            <span class="Toggle-label">Make Default</span>
                            <input id="defaultPaymentMethod"
                                   name="defaultPaymentMethod"
                                   class="HOA-Toggle HOA-Round-Toggle"
                                   type="checkbox"
                                   tid="makeDefault"
                                   [(ngModel)]="checkingAccount.defaultPaymentMethod">
                            <label for="defaultPaymentMethod" tid="makeDefault"></label>
                        </div>
                    </div>
                </div>
                <div class=" HOA-flextable-component HOA-flextable-component__form">
                    <div [ngClass]="{'is-invalid': accountNumberErrorMsg}" class="Field HOA-flextable-component__cell-input">
                        <div class="HOA-flex-center-info-button">
                            <label class="Field-label HOA-flex-center-info-button" for="accountNumber">
                                Account Number
                                <span class="asterisk-required">&nbsp;&#42;</span>
                            </label>
                            <button type="button"
                                    tid="accountNumberHelper"
                                    id="accountNumberHelper"
                                    class="u-mL2 u-pB2 u-posRelative HOA-flex-center-info-button"
                                    (click)="accountNumberHelper()">
                                <span class="Icon Icon--24 u-iconBlue">
                                    <svg focusable="false"
                                         xmlns="http://www.w3.org/2000/svg"
                                         width="24"
                                         height="24"
                                         viewBox="0 0 72 72">
                                        <title>Account Number</title>
                                        <path class="stroke_layer"
                                              d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z"
                                              fill="none"
                                              stroke="#838383"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              stroke-width="3.8">
                                        </path>
                                        <path class="fill_layer"
                                              d="M35.3 49.3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
                                              fill="#838383"
                                              stroke-width="3.8">
                                        </path>
                                        <path class="stroke_layer"
                                              data-name="stroke_layer"
                                              d="M29.2 25.8a8.4 8.4 0 0 1 2.4-4.8 6.5 6.5 0 0 1 4.8-1.8 8.5 8.5 0
                                                  0 1 2.7.4 6.2 6.2 0 0 1 2.2 1.3 5.9 5.9 0 0 1 1.4 2.1 7.4 7.4 0 0 1
                                                  .5 2.9 7.7 7.7 0 0 1-.2 2 6.5 6.5 0 0 1-.6 1.5l-.9 1.3-1.2 1.3-1.5
                                                  1.4a9.9 9.9 0 0 0-1.7 1.8 8.6 8.6 0 0 0-1 1.8 7.5 7.5 0 0 0-.5 1.8
                                                  12.3 12.3 0 0 0-.1 1.7v2.6"
                                              fill="none"
                                              stroke="#838383"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              stroke-width="3.8">
                                        </path>
                                    </svg>
                                </span>
                            </button>
                        </div>
                        <input type="text"
                               stopccp
                               app-allow-pattern
                               allowPattern="^([0-9]*)(-|[0-9])([0-9]*)\$"
                               minlength="3"
                               maxlength="17"
                               class="Input"
                               id="accountNumber"
                               name="accountNumber"
                               tid="accountNumber" [(ngModel)]="checkingAccount.accountNumber"
                               (change)="numberValidation()"
                               autocapitalize="off"
                               autocomplete="off"
                               autocorrect="off"
                               spellcheck="false"
                               required
                               attr.aria-invalid="{{!!accountNumberErrorMsg}}"
                               attr.aria-describedby="{{accountNumberErrorMsg && 'accountNumber-error' || undefined }}">
                        <span class="Field-error" id="accountNumber-error">{{accountNumberErrorMsg}}</span>
                    </div>
                    <div [ngClass]="{'is-invalid': accountNumberConfirmErrorMsg}"
                         class="Field HOA-flextable-component__cell-input HOA-CheckingAccount-padding-top-sm12-lg2">
                        <label class="Field-label" for="accountNumberConfirm">
                            Confirm Account Number
                            <span class="asterisk-required">&nbsp;&#42;</span>
                        </label>
                        <input type="text"
                               stopccp
                               app-allow-pattern allowPattern="^([0-9]*)(-|[0-9])([0-9]*)\$"
                               minlength="3"
                               maxlength="17"
                               class="Input"
                               id="accountNumberConfirm"
                               name="accountNumberConfirm"
                               tid="accountNumberConfirm"
                               [(ngModel)]="checkingAccount.accountNumberConfirm"
                               (change)="numberValidation()"
                               autocapitalize="off"
                               autocomplete="off"
                               autocorrect="off"
                               spellcheck="false"
                               required
                               attr.aria-invalid="{{!!accountNumberErrorMsg}}"
                               attr.aria-describedby="{{accountNumberErrorMsg && 'accountNumberConfirm-error' || undefined }}">
                        <span class="Field-error" id="accountNumberConfirm-error">{{accountNumberConfirmErrorMsg}}</span>
                    </div>
                </div>
                <div class="HOA-flextable-component HOA-flextable-component__form">
                    <div class="Field HOA-flextable-component__cell-input">
                        <label class="Field-label" for="savingsAcctCheckbox">
                            Is this a savings account?
                        </label>
                        <div class="Select">
                            <select
                                    tid="savingsAcctCheckbox"
                                    id="savingsAcctCheckbox"
                                    name="savingsAcctCheckbox"
                                    [(ngModel)]="checkingAccount.savingsAccountIndicator">
                                <option [ngValue]="'checking'">No</option>
                                <option [ngValue]="'savings'">Yes</option>
                            </select>
                            <span class="Select-arrow"></span>
                        </div>
                    </div>
                </div>
                <div class="Field">
                    <label class="Field-label">
                        Account Nickname
                        <span class="asterisk-required">&nbsp;&#42;</span>
                    </label>
                    <input type="text"
                           class="Input"
                           id="accountNickname"
                           name="accountNickname"
                           tid="accountNickname"
                           maxlength="50"
                           [(ngModel)]="checkingAccount.nickname"
                           required>
                </div>
                <div class="HOA-Checking-Detail-button-container">
                    <button name="cancel"
                            id="cancel"
                            tid="cancel"
                            type="button"
                            class="Button Button--link"
                            (click)="cancel()">
                        Cancel
                    </button>
                    <button name="submit"
                            id="submit"
                            tid="submit"
                            type="submit"
                            class="Button Button--blue"
                            ifOverFlowXClass="Button--overflowX"
                            [disabled]="invalid()">
                        Add Bank Account
                    </button>
                </div>
                <div class="u-pT2 HOA-flex-component HOA-font-fine-print">
                    <span class="asterisk-required">&#42;</span>&nbsp;Indicates required field
                </div>
            </div>
        </div>
    </form>
</app-page-content>
`;
// Exports
module.exports = code;